import React, { useRef } from 'react';
import OptimizeBanner from './DesktopPages/Page1';
import Page2 from './DesktopPages/Page2';
import Page3 from './DesktopPages/Page3';
import Page4 from './DesktopPages/Page4';
import Page5 from './DesktopPages/Page5';
import Navbar from './components/Navbar';
import { Box } from '@mui/material';
import './App.css';

function App() {
  const page1Ref = useRef(null);
  const page2Ref = useRef(null);
  const page3Ref = useRef(null);
  const page4Ref = useRef(null);
  const page5Ref = useRef(null);

  const scrollToPage1 = () => {
    if (page1Ref.current) {
      page1Ref.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  const scrollToPage2 = () => {
    if (page2Ref.current) {
      page2Ref.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  const scrollToPage3 = () => {
    if (page3Ref.current) {
      page3Ref.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  const scrollToPage4 = () => {
    if (page4Ref.current) {
      page4Ref.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  const scrollToPage5 = () => {
    if (page5Ref.current) {
      page5Ref.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  return (
    <Box 
      sx={{ 
        position: 'relative',
        backgroundColor: '#000000',
        minHeight: '400vh',
        overflowX: 'hidden',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          display: 'none'
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none'
      }}
    >
      {/* Fixed Navbar for all pages */}
      <Navbar 
        onLogoClick={scrollToPage1} 
        onJoinClick={scrollToPage5} 
        isMobile={false} 
      />

      <Box 
        ref={page1Ref}
        sx={{ 
          height: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <OptimizeBanner />
      </Box>

      <Box 
        ref={page2Ref}
        sx={{ 
          height: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <Page2 />
      </Box>

      <Box 
        ref={page3Ref}
        sx={{ 
          height: '100vh',
          position: 'relative',
          zIndex: 1,
          marginBottom: '15vh'
        }}
      >
        <Page3 />
      </Box>

      <Box 
        ref={page4Ref}
        sx={{ 
          height: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <Page4 />
      </Box>

      <Box 
        ref={page5Ref}
        sx={{ 
          height: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <Page5 />
      </Box>
    </Box>
  );
}

export default App;